import React, { Component } from 'react';
import { connect } from 'react-redux';
import Lightbox from 'react-image-lightbox';
import { ImageData } from './Art';
import 'react-image-lightbox/style.css';

// const images = ImageData.map(d => d.src);
// const titles = ImageData.map(d => d.title);
// const dimensions = ImageData.map(d => d.dimensions);
// const mediums = ImageData.map(d => d.medium);


class ArtScroller extends Component {
  constructor(props) {
    super(props);

    this.setPhotoIndex(0);
  }

  setPhotoIndex(index, isOpen = true) {
    const boundedIndex = (index + ImageData.length) % ImageData.length
    const art = ImageData[boundedIndex]
    const photoTitle = art.title
    const photoDetail = `${art.dimensions} ${art.medium}`
    this.props.setState(
      {
        photoIndex: boundedIndex,
        isOpen,
        photoTitle,
        photoDetail,
      });
  }

  modalStyle() {
    return {
      overlay: {
        position: 'fixed',
        top: this.props.top + 'px',
        bottom: this.props.bottom + 'px',
      }
    }
  }
  

  render() {
    console.log(`props: ${JSON.stringify(this.props, null, 0)}`)
    const { photoIndex, isOpen } = this.props
    const art = ImageData[photoIndex]
    const nextArt = ImageData[(photoIndex + 1) % ImageData.length]
    const prevArt = ImageData[(photoIndex + ImageData.length - 1) % ImageData.length]
    return (
      <div>
        {isOpen && (
          <Lightbox
            reactModalStyle={this.modalStyle()}
            mainSrc={art.src}
            nextSrc={nextArt.src}
            prevSrc={prevArt.src}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() => this.setPhotoIndex(photoIndex - 1)}
            onMoveNextRequest={() => this.setPhotoIndex(photoIndex + 1)}
            clickOutsideToClose={false}
            hideClose={true}
            />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  ...state.artScroller,
  top: state.sizing.headerHeight,
  bottom: state.sizing.footerHeight + state.sizing.footerSpace,
});

const mapDispatchToProps = (dispatch) => ({
  setState: (updates) => dispatch({ type: "UPDATES", artScroller: updates })
})

export default connect(mapStateToProps, mapDispatchToProps)(ArtScroller);

  



// WEBPACK FOOTER //
// ./src/ArtScroller.js